import Image from 'next/image';
import Link from 'next/link';
import { Button } from '@/components/button';
import { Countdown } from '@/components/Countdown';
import type { PoweredBy } from '@/types/sponsor';

export const PickemsRewardsHeader = ({
  title,
  description,
  poweredBy,
  countdownDatetime,
  countdownLabel,
  leaderboardUrl,
}: {
  poweredBy: PoweredBy;
  title: string;
  description: string;
  countdownDatetime: Date;
  countdownLabel: string;
  leaderboardUrl: string;
}) => {
  return (
    <div className="mb-5 flex w-full flex-col justify-between gap-12 md:flex-row md:items-center">
      <div className="flex flex-col gap-6 md:flex-row md:items-center">
        <div className="relative h-8 w-40 rounded-lg p-8">
          <Link href={poweredBy.url} target="_blank">
            <Image
              alt={poweredBy.name}
              className="object-contain"
              fill
              src={poweredBy.logo.url}
            />
          </Link>
        </div>
        <div>
          <h2 className="mb-2 font-semibold text-xl">{title}</h2>
          <p>{description}</p>
        </div>
      </div>

      <div className="mb-4 flex flex-col gap-4 md:items-center">
        <p className="whitespace-nowrap text-gray text-sm md:text-center">
          {countdownLabel}
        </p>
        <Countdown targetDate={countdownDatetime} />
        <Button as="link" href={leaderboardUrl} size="lg" variant="secondary">
          View leaderboard
        </Button>
      </div>
    </div>
  );
};
